export default [
  {
    type: 'STRING',
    name: 'name',
    defaultName: 'Name',
  },
  {
    type: 'STRING',
    name: 'description',
    defaultName: 'Description',
  },
  {
    type: 'BOOLEAN',
    name: 'active',
    defaultName: 'Active',
  },
  {
    type: 'STRING',
    name: 'owner',
    defaultName: 'Owner',
  },
  {
    type: 'STRING',
    name: 'id',
    defaultName: 'Id',
  },
  {
    type: 'DATETIME',
    name: 'created',
    defaultName: 'Created',
  },
  {
    type: 'DATETIME',
    name: 'updated',
    defaultName: 'Updated',
  },
  {
    type: 'BOOLEAN',
    name: 'deleted',
    defaultName: 'Deleted',
  },
  {
    type: 'INT',
    name: 'version',
    defaultName: 'Version',
  },
  {
    type: 'STRING',
    name: 'processedMedia',
    defaultName: 'Processed Media',
  },
  {
    type: 'BOOLEAN',
    name: 'released',
    defaultName: 'Released',
  },
  {
    type: 'STRING',
    name: 'media',
    defaultName: 'Media',
  },
]
